import React, { useState, useRef, useEffect, useContext } from "react";
import { useHistory, NavLink } from "react-router-dom";
import { Container, Grid, Image, Form, Icon, Button } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import atar_logo from "../../assets/home/atar_logo.png";
import "react-datepicker/dist/react-datepicker.css";
import error from "../../assets/home/error.gif";
import { StarButton } from '../../components'

const Fourscreen = () => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);
  const history = useHistory();

  return (
    <div className="container_bg clearall">

      <NavLink to=""><Image className="logo_img" src={atar_logo} /></NavLink>
      <div className="celeb_bg">

        <Image className="heading_img" src={error} />
        <p>{t("fourscreen.para")}</p>
        <div className="clearall destops">
          <div className="fourbt">
            <StarButton background={'mainBg'} width="350px" title={t("fourscreen.btn")} onClickAction={() => history.push('/')} />
          </div>
        </div>
      </div>
      <div className="mobiles">
        <StarButton background={'mainBg'} width="350px" title={t("fourscreen.btn")} onClickAction={() => history.push('/')} />
      </div>
    </div>
  );
};

export default Fourscreen